import * as angular from "angular";

angular
  .module('bringoz.admin.service-points')
  .config(servicePointsConfig);

/* ngInject */
function servicePointsConfig($stateProvider) {

  $stateProvider

    // Service Points
    .state('service-points', {
      parent: 'bringoz.site',
      url: '/service-points',
      template: '<service-points-view></service-points-view>',
      controller: function (triBreadcrumbsService, site) {

        // Bread Crumbs
        triBreadcrumbsService.reset();
        triBreadcrumbsService.addCrumb({name: "Service Points"});
        triBreadcrumbsService.addCrumb({name: "Shippers"});
      }
    })
}
